module.exports = __webpack_public_path__ + "static/img/Alex-Conti.d843a83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Alex-Conti.jpg
// module id = o/Nc
// module chunks = 0